<template>
  <div>
    <mobile-page v-if="isH5 || isMini" />
    <pc-page v-else />
  </div>
</template>

<script>
import PcPage from "@saas/pages/src/homework/pc/Index.vue";
import MobilePage from "@saas/pages/src/homework/mobile/Index.vue";
import { isH5, isHXApp, isMini, isMGAppInPad } from "@saas/components/src";
import { mapState, mapMutations, mapActions, mapGetters } from "vuex";
export default {
  data: function () {
    return {
      isH5: false,
      isMini: false,
      isHXApp: isHXApp(),
    };
  },
  components: {
    PcPage,
    MobilePage,
  },
  created() {
    this.isH5 = document.body.clientWidth < 520;
    this.isMini = isMini();
    this.setIsMobile(this.isH5);
    if (this.isMini && this.$route.query?.activityName) {
      document.title = this.$route.query.activityName;
    }
    if (this.isMini) {
      // 创建 script 元素
      const script = document.createElement("script");
      script.type = "text/javascript";
      script.src = "https://res.wx.qq.com/open/js/jweixin-1.3.2.js";
      // 将 script 元素添加到 head 中
      document.head.appendChild(script);

      // 可以添加回调来处理脚本加载完成后的操作
      script.onload = () => {
        console.log("微信 JS SDK 加载完成");
        // 在这里可以使用 wx 对象进行相关操作
      };
      window.addEventListener("popstate", (e) => {
        // eslint-disable-next-line no-undef
        wx.miniProgram.navigateBack(); // 返回小程序
        // eslint-disable-next-line no-undef
        wx.miniProgram.postMessage({
          data: {
            action: "back",
          },
        });
      });
    }
  },
  methods: {
    ...mapMutations("defaultHomework", ["setIsMobile"]),
  },
  computed: {
    ...mapState("defaultHomework", ["workInfo"]),
  },
};
</script>

<style lang="scss" scoped></style>
